import React from 'react';
import { isEmpty } from 'lodash';

import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import Modal from '@material-ui/core/Modal';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import ACSelect from '../../atoms/ACSelect';

import ACButton from '../../atoms/ACButton';

import colors from '../../common/colors';
import styles from './SetStop.module.scss';

export default class SetStop extends React.Component {
  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false);
  }

  onKeyDown = (event) => {
    if (event.keyCode === 27) {
      //Escape key
      this.props.onCloseFunc();
    }
  };

  onInputChangeSparkName = (query) => {
    if (isEmpty(query)) return null;

    this.props.onInputChangeSparkFunc(query);
  };

  onSaveStop = () => {
    this.props.onSaveStopFunc();
  };

  onDeleteStop = (deleteSparkIndex) => {
    this.props.onDeleteStopFunc(deleteSparkIndex);
  };

  onDeleteStopSpark = (sparkId) => {
    this.props.onDeleteStopSparkFunc(sparkId);
  };

  onChangeClue = (clue) => {
    this.props.onSelectClueFunc(clue);
  };

  onChangeSelect = (name, selectedOption) => {
    if (isEmpty(name)) return;

    this.props.onSelectFunc(name, selectedOption);
  };

  onChangeStopText = (e) => {
    if (isEmpty(e) || isEmpty(e.target)) return null;
    const { name = '', value = '' } = e.target;

    this.props.onChangeStopFunc(name, value);
  };

  getSuitables(suitables) {
    let suitableComponents = [];
    // console.log('suitables', suitables);
    if (suitables) {
      suitables.forEach((s) => {
        let adults = s.adults || 0;
        let children = s.children || 0;

        if (!(adults <= 0 && children <= 0)) {
          suitableComponents.push(
            <div
              style={{
                margin: '3px',
              }}
            >
              <Chip
                label={adults}
                style={{
                  visibility: adults ? 'visible' : 'collapse',
                  backgroundColor: 'black',
                  borderColor: 'black',
                  color: 'white',
                  fontSize: '12px',
                }}
                className={styles.circle}
              />
              <Chip
                label={children}
                style={{
                  visibility: children ? 'visible' : 'collapse',
                  backgroundColor: 'white',
                  borderColor: 'black',
                  color: 'black',
                  fontSize: '12px',
                }}
                className={styles.circle}
              />
            </div>
          );
        }
      });
    }
    return suitableComponents;
  }

  renderTopPanel() {
    const { stop = {}, onCloseFunc } = this.props;
    const { index = -1 } = stop;
    const showDeleteIcon = index >= 0 ? true : false;

    let deleteIcon = <div />;
    if (showDeleteIcon === true) {
      deleteIcon = (
        <div className={styles.topBarIcon}>
          <DeleteIcon
            style={{
              color: '#FF765F',
            }}
            //While called from Planner level, use onDeleteStopSpark to delete the spark stop; else from route level use onDeleteStop
            onClick={() => this.props.onDeleteStopSparkFunc ? this.onDeleteStopSpark(stop.sparkId) : this.onDeleteStop(stop.index)}
          />
        </div>
      );
    }

    return (
      <div className={styles.top}>
        <div>
          <h3>Set Stop</h3>
        </div>
        {deleteIcon}
        <div
          className={styles.topBarIcon}
          style={{
            marginRight: '0',
          }}
        >
          <CloseIcon onClick={onCloseFunc} />
        </div>
      </div>
    );
  }

  renderSpark() {
    const { sparks = [], stop } = this.props;
    const { spark = {} } = stop;
    let updatedSparks = [];
    if (!isEmpty(sparks)) {
      let name = '';
      let privateNote = '';
      updatedSparks = sparks.map((s) => {
        const newSpark = {...s};
        const { note = {} } = newSpark;
        name = newSpark.name || '';
        privateNote = note.private ? ` - ${note.private}` : '';
        newSpark.name = `${name}${privateNote}`
        return newSpark;
      });
    }

    return (
      <div className={styles.select}>
        <div className={styles.selectLabel}>Connection Spark</div>
        <ACSelect
          name="spark"
          showLabel={false}
          options={updatedSparks}
          option={spark}
          optionLabel={'name'}
          optionValue={'id'}
          onChangeFunc={this.onChangeSelect}
          onInputChangeOptionFunc={this.onInputChangeSparkName}
        />
      </div>
    );
  }

  renderChallenge() {
    const { challenges = [], stop } = this.props;
    challenges.forEach((challenge) => {
      const { subChallenges = [], status } = challenge;
      if (status === 'inactive') {
        challenge.highlightColor = colors.acOrange;
      } else if (status === 'archived') {
        challenge.highlightColor = colors.red;
      } else if (!isEmpty(subChallenges) && subChallenges.length > 0) {
        challenge.highlightColor = colors.acBlue;
      }
    });

    const { challenge = {} } = stop;
    return (
      <div className={styles.select}>
        <div className={styles.selectLabel}>Challenge</div>
        <ACSelect
          name="challenge"
          maxOptions={300}
          showLabel={false}
          options={challenges}
          option={challenge}
          optionLabel={'name'}
          optionValue={'id'}
          onChangeFunc={this.onChangeSelect}
        />
      </div>
    );
  }

  renderClues() {
    const { clues = [], stop = {} } = this.props;
    const clue = stop.clue || {};

    return (
      <div className={styles.cluesRender}>
        <div className={styles.title}>Available Clues</div>
        {
          <List className={styles.clueList}>
            {clues.map((c) => {
              let s = [styles.clue];
              if (c && c.id === clue.id) {
                s.push(styles.selected);
              }
              return (
                <ListItem
                  key={clue.id}
                  className={s.join(' ')}
                  onClick={() => this.onChangeClue(c)}
                >
                  <span className={styles.clueName}>{c.name}</span>
                </ListItem>
              );
            })}
          </List>
        }
      </div>
    );
  }

  renderNotes(action) {
    return (
      <div className={styles.action}>
        <span>Internal Notes</span>
        <TextField
          name="action"
          value={action}
          className={styles.action}
          onChange={this.onChangeStopText}
        />
      </div>
    );
  }

  render() {
    const { stop = {}, isModalOpen = false, onCloseFunc } = this.props;

    const { action = '' } = stop;

    return (
      <Modal open={isModalOpen} onClose={onCloseFunc} className={styles.root}>
        <div className={styles.list}>
          {this.renderTopPanel()}
          {this.renderSpark()}
          {this.renderChallenge()}
          {this.renderClues()}
          {this.renderNotes(action)}
          <div className={styles.saveButton}>
            <ACButton
              zIndex='0'
              position='relative'
              bottom='10px'
              text={'Save'}
              icon={<SaveIcon />}
              iconLast={true}
              onClickFunc={this.onSaveStop}
            />
          </div>
        </div>
      </Modal>
    );
  }
}
